<template>
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 2V26.4444V32H18.0714H26.1071H32" stroke="#626262" stroke-width="3" stroke-linecap="square"/>
    <path d="M6 12.8119H12.3546L15.5319 9.06188L19.7164 14L24.2695 7.39522" stroke="#626262" stroke-width="3"/>
    <path d="M10 19H7C6.44772 19 6 19.4477 6 20V27C6 27.5523 6.44772 28 7 28H10C10.5523 28 11 27.5523 11 27V23.5V20C11 19.4477 10.5523 19 10 19Z" fill="#626262" stroke="#626262" stroke-linecap="round"/>
    <path d="M18.7295 19.7115L15.5084 16.2757C15.3435 16.0998 15.1132 16 14.8722 16C14.3905 16 14 16.3905 14 16.8722V27C14 27.5523 14.4477 28 15 28H15.25H18C18.5523 28 19 27.5523 19 27V20.3954C19 20.1414 18.9033 19.8969 18.7295 19.7115Z" fill="#626262" stroke="#626262" stroke-linecap="round"/>
    <path d="M29.1154 2.64154L26.747 10.9381L21.1053 4.6308L29.1154 2.64154Z" fill="#626262"/>
    <path d="M25.2854 18.7513L22.2854 21.8156C22.1025 22.0025 22 22.2536 22 22.5152V27C22 27.5523 22.4477 28 23 28H26C26.5523 28 27 27.5523 27 27V22.5V19.4509C27 18.5548 25.9123 18.111 25.2854 18.7513Z" fill="#626262" stroke="#626262" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: "ProjecaoVendasPersonalizada",
}
</script>

<style scoped>

</style>
